export const phrases = {
  heading_settings_sort: "Ordenar la lista de personal",
  body_settings_sort: "Ordenar la lista de personal por nombre o apellido.",
  since_o_clock: "Desde {time} clock",
  old_data_warning_my_area: "No hemos podido cargar ninguna información nueva. Asegúrese de que está conectado a Internet.",
  no_data_warning_my_area: "Asegúrate de que estás conectado a Internet e inténtalo de nuevo.",
  no_data_available_my_area: "No se pueden cargar datos",
  last_update_data: "Última actualización",
  something_went_wrong_absences: "Algo ha ido mal. Vuelva a intentarlo más tarde.",
  something_went_wrong_with_the_pin_entry: "Algo salió mal con la introducción del PIN...",
  pin_must_be_four_digits: "El PIN debe constar exactamente de cuatro dígitos.",
  pins_do_not_match: "Los PIN introducidos no coinciden.",
  pin_is_not_numerical: "El PIN sólo puede estar formado por números.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Eliminar",
  finish_break: "Fin de la pausa",
  finish_loading_time: "Tiempo de carga final",
  finish_driving_time: "Fin del tiempo de conducción",
  finish_business_trip: "Fin del servicio",
  finish_project_as_task: "Finalizar proyecto",
  finish_special_one: "Fin especial1",
  finish_special_two: "Fin Special2",
  you_clockout: "Te estampas",
  sentence_work_time: "Estás trabajando. | Estás trabajando ahora mismo.",
  sentence_break: "Te estás tomando un descanso. | Te estás tomando un descanso.",
  sentence_loading_time: "Está registrando el tiempo de carga. ¡Hauruck! | Está grabando el tiempo de carga. ¡Idiota!",
  sentence_business_trip: "Servicio conectado. ¡Diviértete!",
  sentence_driving_time: "Estás reservando tiempo de conducción. Abróchate el cinturón y vete. | Estás reservando tiempo de viaje. ¡Abróchate el cinturón y vete!",
  sentence_special_one: "Está reservando Especial 1. | Está reservando el especial 1.",
  sentence_special_two: "Está reservando Especial 2. | Está reservando el especial 2.",
  sentence_custom_time: "Está reservando | Está reservando",
  you_are_booked_in_activity: "¡Usted estampa {activity}! | ¡Usted estampa {activity}!",
  substitute_warning: "{ days } Debe nombrarse un suplente para ausencias de días o más.",
  substituted_by: "Representado por",
  name_clocked_in: "{name} estampado",
  /************************************/
  //Signature stuff:

  signature: "Firma",
  please_sign: "Por favor firme",
  signature_with_date: "Firma de {date}",
  signature_with_date_with_name: "Firma de {date} de {name}",
  signature_with_date_with_location: "Signature from {date} in {location}",
  signature_with_date_with_name_with_location: "Firma de {date} de {name} en {location}",
  signature_with_name: "Firma de {name}",
  signature_with_name_with_location: "Firma de {name} en {location}",
  signature_with_location: "Firma en {location}",
  /*************************************/

  accept_terms_and_conditions: "Al enviar el formulario acepta nuestra {agb} y nuestra {datenschutzerklaerung}.",
  what_is_your_name: "¿Cómo te llamas?",
  your_email: "Su dirección de correo electrónico",
  what_is_your_company_name: "¿Cuál es el nombre de su empresa?",
  what_do_you_want_to_do_with_clockin: "¿Qué quieres hacer con clockin?",
  almost_finished: "Ya casi está",
  test_clockin_for_amount_period: "¡Prueba clockin {amountOfDaysTestPeriod} gratis durante unos días!",
  code_needed_to_connect: "Utilice su código",
  you_have_no_company_code: "¿No tiene un código? Póngase en contacto con la persona de su empresa.",
  connect_your_device: "Conecta tu dispositivo",
  please_type_in_device_id: "Introduce el ID del dispositivo, que encontrarás en la sección de dispositivos móviles de nuestro sitio web.",
  new_at_clockin: "¿Eres nuevo en el reloj?",
  pin_repeat: "Repetir PIN",
  configure_your_pin: "Establezca su PIN de 4 dígitos",
  configure_your_pin_text: "Necesita el PIN para acceder a su área personal en el terminal de la tableta.",
  congratulations: "¡Felicidades!",
  start_now: "Empezar ahora",
  device_name_info: "Puede cambiar el nombre de dispositivo de su dispositivo móvil para poder realizar un seguimiento de varios dispositivos. Ejemplo: \"Smartphone MaxMustermann\". El nombre también se puede cambiar posteriormente.",
  select_project: "Seleccionar proyecto",
  select_time: "Tiempo seleccionado",
  create_new_account: "Crear una nueva cuenta",
  join_my_company: "Únete a mi empresa",
  join_clockin_with_qr: "Únete con el código QR",
  change_project: "Proyecto de cambio",
  my_messages: "Mis noticias",
  my_documents: "Mis documentos",
  my_data_and_passwords: "Mis datos y contraseñas",
  my_account_data: "Mis datos",
  change_my_password: "Cambiar contraseña",
  forgot_password: "No sé mi contraseña.",
  open_camera: "Cámara abierta",
  scan_now: "Escanear ahora",
  sync_now: "Sincronizar ahora",
  clear_logs: "Registros vacíos",
  saveAndGoBack: "Guardar y volver",
  full_day: "Jornada completa",
  activate_scanner: "Escáner activado",
  scanner_is_inactive: "Escáner inactivo",
  change_project_by_scan_qr: "Escanee el código QR del proyecto al que desea cambiar.",
  scan_device_by_qr: "Escanee el código QR desde el dispositivo que desee utilizar.",
  no_access_to_camera_please_connect_device_manually: "Lamentablemente, no se ha podido acceder a la cámara, por favor, introduzca el código del dispositivo manualmente.",
  no_access_to_camera_please_clockin_manually: "Lamentablemente, no fue posible acceder a la cámara, por favor, estampe su sello manualmente.",
  qr_code_login: "Registro con código QR",
  scan_to_login: "Escanee su código QR para iniciar sesión.",
  checklist_was_saved: "Se guardó la lista de comprobación",
  question_save_changes_short: "¿Guardar cambios?",
  question_save_changes: "¿Quieres guardar los cambios?",
  question_delete_checklist_short: "¿Borrar la lista de control?",
  question_delete_checklist: "¿Estás seguro de que quieres borrar la lista de control?",
  checklist_is_sending: "Se enviará una lista de verificación",
  checklist_sent_successfully: "Lista de verificación enviada con éxito 🎉",
  checklist_could_not_be_sent: "No se pudo enviar la lista de verificación, inténtelo de nuevo más tarde.",
  checklist_transmission_problems_in_the_past: "En el pasado, ha habido problemas de transferencia con algunos archivos.",
  checklist_send_with_potential_data_loss: "¿Le gustaría intentar enviar la lista de verificación sin estos archivos?",
  documentation_is_sending: "Envío de la documentación del proyecto",
  documentation_sent_successfully: "Documentación del proyecto enviada con éxito 🎉",
  confirm_documentation_dismissal: "¿De verdad quiere descartar la documentación?",
  discard_unsaved_changes: "¿Quieres desechar tus cambios?",
  documentation_will_be_sent_when_online: "La documentación se enviará en cuanto vuelva a estar en línea.",
  confirmation_is_sending: "Se envía la confirmación del proyecto",
  ask_for_geo_permission: "Esta aplicación necesita tu ubicación, " + "pero carece de permiso para hacerlo.\n\n" + "¿Quieres abrir la configuración?",
  all_projects: "Todos los proyectos",
  half_day: "Media jornada",
  start_end: "Según el tiempo",
  my_area: "Mi zona",
  my_area_video_teaser_clockin_explained_by_frederik: "clockin explicado por Freddi",
  add_time: "Crear tiempo",
  show_times_in_confirmation: "Horario de espectáculos en confirmación",
  change_time: "Tiempo de cambio",
  finish_project: "Proyecto completo",
  finish_project_date: "Finalizar el nombramiento",
  unfinish_project: "Reabrir proyecto",
  unfinish_project_date: "Reabrir cita",
  absence_overview: "Gestionar las ausencias",
  edit_absence: "Editar ausencia",
  edited_absence: "Ausencia editada",
  created_absence: "Solicitud de baja creada con éxito",
  creating_absence: "Su solicitud de excedencia ya está creada",
  error_creating_absence: "Error al crear la solicitud de ausencia",
  create_absence: "Crear ausencia",
  deleted_absence: "Solicitud de ausencia retirada",
  new_request: "Nueva aplicación",
  your_requests: "Sus solicitudes",
  planned_days: "Días programados",
  planned_hours: "Horario programado",
  used_days: "Días utilizados",
  used_hours: "Horas dedicadas",
  free_days: "Días libres",
  free_hours: "Horario de vacaciones",
  open_days: "Jornadas de puertas abiertas",
  open_hours: "Horario de atención",
  withdraw_request: "Retirar la solicitud",
  change_request: "Solicitud de cambio",
  request_was_approved: "Su solicitud ha sido aprobada",
  request_is_pending: "Su solicitud aún no ha sido aprobada",
  request_was_rejected: "Su solicitud ha sido rechazada",
  add_attachment: "Añadir anexo",
  message_optional: "Mensaje (opcional)",
  filed_on: "Enviado el",
  this_year: "Este año",
  search_sub_projects: "¿En qué subproyecto le gustaría trabajar?",
  error_occurred: "Se ha producido un error, inténtelo de nuevo más tarde.",
  re_record: "¿Borrar y volver a grabar este vídeo?",
  delete_video: "¿Borrar grabación?",
  no_results_found: "No se han encontrado resultados",
  record_again: "Reintentar",
  request_valid_email: "Introduzca una dirección de correo electrónico válida.",
  request_valid_company_name: "Introduzca un nombre de empresa válido.",
  request_valid_first_name: "Por favor, introduzca un nombre válido.",
  request_valid_last_name: "Por favor, introduzca un apellido válido.",
  total_duration_today: "Tiempo total hoy",
  show_daily_protocol: "Mostrar registro diario",
  change_profile_pic: "Cambiar la foto de perfil",
  logout_account: "Desconectar cuenta",
  you_are_working: "¡Estás trabajando ahora mismo!",
  you_are_taking_a_break: "¡Estás en un descanso!",
  activity_edited: "Actividad editada",
  activity_edited_undo: "Procesamiento deshecho con éxito",
  activity_edited_missing_project: "¡Aún falta el proyecto!",
  activity_deleted: "Actividad eliminada",
  activity_deleted_undo: "Actividad eliminada restaurada",
  activity_created: "Nueva actividad creada",
  activity_created_undo: "Actividad recién creada retirada",
  correct_working_hours: "Tiempos de trabajo correctos",
  your_changes_are_being_saved: "Los cambios se han guardado.",
  manage_working_hours: "Gestionar la jornada laboral",
  delete_activity: "Borrar actividad",
  start_navigation: "Iniciar la navegación",
  no_valid_email: "La dirección de correo electrónico introducida no es válida.",
  delete_checklist: "Borrar lista de control",
  active_checklists: "Listas de control activas",
  scan_qr_code: "Escanear código QR",
  switch_to_office_center: "Cambiar al centro de oficinas",
  confirm_project_completion_short: "Proyecto completo",
  confirm_project_date_completion_short: "Finalizar el nombramiento",
  project_completed: "Proyecto finalizado.",
  project_date_completed: "Nombramiento definitivo.",
  confirm_project_uncompletion_short: "Reabrir proyecto",
  confirm_project_date_uncompletion_short: "Reabrir cita",
  project_uncompleted: "Proyecto activado",
  project_date_uncompleted: "Fecha de activación",
  choose_project: "Seleccionar proyecto",
  choose_sub_project: "Seleccionar subproyecto",
  choose_site: "Seleccione el lugar",
  active_projects: "Proyectos activos",
  completed_term: "completado",
  completed_projects: "Proyectos realizados",
  end_of_work: "Buenas noches",
  correct_time: "Hora correcta",
  you_stamp_x: "Sello",
  enter_pin: "Introduzca el PIN",
  wrong_pin: "Introducción incorrecta del PIN",
  pin_change_required: "Se le ha pedido que cambie su PIN",
  enter_new_pin: "Introducir nuevo PIN",
  approve_pin: "Confirmar PIN",
  no_projects_scheduled: "Para {day} No se almacenan proyectos.",
  you_clock_in_project: "A partir de ahora, registrará el tiempo de trabajo del proyecto.",
  project_scan_error: "Este código no es válido para ningún proyecto.",
  show_more_days: "mostrar más días",
  show_more_times: "Mostrar más veces",
  only_show_today: "Mostrar sólo hoy",
  todays_total_time: "Tiempo total hoy",
  everything_synced: "Sus datos están actualizados.",
  upload_in_progress: "Los datos se cargan...",
  who_are_you: "¿Quién eres?",
  is_uploading_to_server: "Sus cambios se están transfiriendo al centro de la oficina.",
  offline_and_data_is_stored_locally: "Sus cambios se transferirán en breve al centro de la oficina. ",
  show_more: "ver más",
  activity_edited_wrong_date: "Ha introducido una fecha incorrecta.",
  confirm_logout: "¿De verdad quieres darte de baja?",
  confirm_clockout: "¿Seguro que quieres fichar por hoy?",
  gps_is_active: "Los datos GPS se transmiten",
  location_tracking_is_active: "Para activar el seguimiento por GPS.",
  app_settings: "Configuración de la aplicación",
  clock_reminder: "Sello - Recordatorio",
  mon_to_fri: "Estándar: lunes a viernes",
  logout: "Desconectar cuenta",
  refresh: "Actualización",
  prompt_language_settings: "Ajuste aquí el idioma de la aplicación.",
  prompt_clock_reminder: "Recordatorio mediante notificación push para que se ajuste a tu trabajo diario.",
  register_company: "Registrar empresa",
  use_code: "Utilice el código",
  our_customers: "Nuestros clientes",
  free_test_now: "Prueba gratuita",
  tier_attendance: "Sólo registro las horas de trabajo y las pausas.",
  tier_documentation: "También quiero reservar horas de trabajo en proyectos que gestiono en clockin.",
  your_tier: "Su paquete",
  all_clockin_functions: "Todas las funciones de clockin",
  checklists_formulars: "Listas de control y funciones",
  projectfile_incl_chat: "Archivos digitales del proyecto (incluido chat)",
  photo_sketch_note: "Función de fotos, bocetos y notas",
  digital_signature: "Firmas digitales",
  datev_connection: "Conexión DATEV",
  calendar_absences: "Gestionar el calendario y las ausencias",
  individual_design: "Aspecto individual",
  attendance_time_tracking: "Registro de tiempo estacionario mediante terminal de tableta",
  mobile_time_tracking: "Registro móvil del tiempo a través de una aplicación para smartphone",
  browser_time_tracking: "Grabación del tiempo de navegación en el PC para la oficina en casa",
  help_use_code: "Por favor, introduzca el código que encontrará en el centro de oficinas en dispositivos móviles/empleados.",
  wrong_code: "Código incorrecto",
  wrong_code_text: "El código no es válido. Por favor, inténtelo de nuevo con un código válido",
  wrong_code_text_short: "El código no es válido",
  clockin_logo: "Logotipo de Clockin",
  invalid_qr_code: "Código QR no válido",
  invalid_qr_code_text: "El código QR escaneado no es válido. Escanee un código de fichaje válido.",
  code_already_connected: "Con este código puedes conectar tu dispositivo. Pero ya está conectado.",
  wrong_credentials: "Datos de acceso incorrectos",
  wrong_credentials_text: "No se ha encontrado la combinación de correo electrónico y contraseña que ha introducido. Por favor, compruebe su entrada e inténtelo de nuevo.",
  new_pin: "Introducir nuevo PIN",
  choose_next_action: "Elija su próxima acción",
  name_of_software_package: "Nombre del paquete de software",
  select_teamleader: "¿Quién estampa para el equipo?",
  select_teamleader_description: "Para continuar con las actividades de estampación, por favor seleccione una persona que ahora se hará cargo de la máquina.",
  clocked_in_on_this_device: "Estampado en esta unidad",
  not_clocked_in_on_this_device: "No estampado en esta unidad",
  select_new_teamleader: "¿Quién debería estampar ahora su sello en el equipo?",
  switch_teamleader: "Entrega de la unidad",
  just_me: "Ya me voy",
  select_the_new_teamleader: "Determinar el nuevo jefe de equipo",
  back_to_selection: "volver a la selección",
  manage_team: "Gestionar el equipo",
  total_time_team: "Tiempo total del equipo",
  count_members_clocked_in: "{clockedin}/{members} Miembros del equipo sellados",
  whole_team: "Todo el equipo",
  teammembers_still_clockedin: "Elige si quieres fichar sólo a ti o a todos los miembros del equipo.",
  clockout_all: "Acabar con todo",
  select_employee: "Primero seleccione un usuario",
  something_went_wrong: "Algo ha ido mal, por favor inténtelo más tarde.",
  new_pin_successfully_changed: "PIN cambiado correctamente",
  enter_pin_before_clockin_prompt: "En primer lugar, introduzca su PIN de uno en uno para fichar.",
  enter_pin_before_clockout_prompt: "Primero introduzca su PIN de uno en uno para fichar.",
  delete_activity_alert_title: "Borrar actividad",
  delete_activity_alert_msg: "¿Estás seguro de que quieres borrar la actividad?",
  delete_absence_message: "¿Está seguro de que desea retirar la solicitud?",
  delete_absence_title: "Retirar la solicitud",
  are_you_sure: "¿Seguro?",
  request_password: "Solicitar nueva contraseña",
  password_requested: "Un enlace para una nueva contraseña ha sido enviado a su dirección de correo electrónico.",
  no_email_retrieved: "¿No has recibido el correo electrónico? Compruebe su carpeta de correo no deseado o inténtelo de nuevo.",
  name_of_customer: "Nombre del cliente",
  missing_permissions_homepage_text: "No tiene permiso para cambiar su actividad en esta máquina. Póngase en contacto con su administrador para obtener acceso.",
  no_permission_warning_my_area: "No tiene permiso para acceder a esta área. Póngase en contacto con su administrador para obtener acceso.",
  employee_clocked_in: "{name} ¡Inscrito!",
  employee_clocked_out: "{name} ¡desconectado!",
  no_employee_to_qr_code_warning: "No se ha encontrado ningún empleado para este código QR.",
  no_employees_registered_heading: "Aún no se ha asignado personal a esta unidad.",
  no_employees_registered_body: "En el centro de la oficina, en la configuración del dispositivo móvil, puede asignar empleados que podrán registrar sus tiempos en este dispositivo.",
  no_employee_found: "Lamentablemente, no se ha podido encontrar a nadie con este nombre.",
  no_employee_assigned: "No asignado ningún empleado",
  you_need_help: "¿Necesitas ayuda?",
  here_you_can_get_help_to_register_employees_for_device: "Aquí encontrará toda la información sobre cómo asignar personal a una unidad.",
  show_time: "Crear tiempo",
  export_timesheet: "Exportar hoja de horas",
  select_month: "Seleccione el mes",
  internet_connection_required: "Para ello se necesita una conexión a Internet.",
  select_an_activity_to_clockin_your_team: "Seleccione una actividad para estampar en su equipo.",
  confirm_uploading_sqlite_for_debugging: "¿Está seguro de que desea cargar los datos en la aplicación para la compatibilidad con Clockin?",
  no_tasks_available: "No hay tareas disponibles",
  click_to_add_tasks: "Haz clic para añadir tareas",
  scan_nfc_tag: "Sostenga su tarjeta frente al lector.",
  link_nfc_tag: "Vincular etiqueta NFC",
  select_employee_for_nfc_tag: "Seleccione un empleado para vincular esta etiqueta NFC:",
  nfc_tag_linked_successfully: "NFC correctamente con {name} enlazado.",
  nfc_linking_failed: "No se pudo vincular la etiqueta NFC. Por favor, inténtalo de nuevo.",
  nfc_not_enabled: "NFC no es compatible con este dispositivo o está deshabilitado.",
  nfc_initialization_failed: "Desafortunadamente, algo salió mal. Por favor, inténtalo de nuevo.",
  nfc_scan_failed: "Desafortunadamente, algo salió mal. Por favor, inténtalo de nuevo.",
  nfc_no_tag_found: "No se encontró ninguna etiqueta NFC.",
  nfc_tag_already_linked_to: "Esta etiqueta NFC ya está disponible con {name} enlazado.",
  nfc_scan_active: "Análisis NFC activo",
  nfc_linking_enabled: "Las etiquetas NFC ahora se pueden vincular. Mantenga presionada la etiqueta NFC para vincularse al lector NFC ahora.",
  nfc_all_employees_linked: "Todos los empleados asignados a este dispositivo ya han sido vinculados.",
  no_employee_to_nfc_warning: "No se pudo encontrar ningún empleado para esta etiqueta NFC.",
  select_employee_to_link_nfc: "¿A quién debe vincularse la etiqueta NFC?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Bienvenido a Clockin",
        clocking_time: "Tiempos en pista",
        push_notifications: "No olvides nada"
      },
      text: {
        clocking_time: "El cronómetro es tu punto de partida para cada actividad. Tú te encargas de tu trabajo, la app se encarga de la documentación.",
        push_notifications: "Ahora activa las notificaciones. Clockin te recuerda si olvidas un sello y se asegura de que todo lo importante sea inmediato."
      },
      button: {
        lets_go: "Empezar ahora"
      }
    },
    my_area: {
      heading: {
        my_area: "Mi zona",
        absences: "Ausencias y solicitudes",
        settings: "Ajustes personales"
      },
      text: {
        my_area: "El lugar central donde tendrá una visión general instantánea de sus horas de trabajo y horas extraordinarias. Desde aquí puedes gestionar tus horas de trabajo, acceder a tu registro diario, enviar solicitudes y consultar tus tiempos.",
        absences: "Gestione las solicitudes de vacaciones, días de baja por enfermedad y otras ausencias. Controle en todo momento el estado de sus solicitudes y envíe otras nuevas de forma rápida y sencilla con solo unos clics.",
        settings: "Envía mensajes a la empresa o cambia tu configuración personal y, si quieres cambiar tu contraseña, ¡también puedes hacerlo aquí!"
      },
      button: {
        lets_go: "Empieza"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Porque tu tiempo cuenta",
        clock_in: "Sello en",
        switch_task: "Cambio de sello",
        clock_out: "Eliminar",
        thats_it: "¡Eso es!"
      },
      text: {
        your_time_matters: "Con clockin le ayudamos a concentrarse en lo esencial. Registre su tiempo de trabajo con un solo clic.",
        clock_in: "Con un solo clic podrás fichar directamente. Clockin guarda tus datos automáticamente y lo tienes todo a la vista en todo momento.",
        switch_task: "¿Tienes otro proyecto, te tomas un descanso o te diriges a tu próxima cita? Sólo tienes que volver a marcar tu nueva actividad. El resto se registra automáticamente.",
        clock_out: "Y con un clic te quedas fuera.",
        thats_it: "Ya lo ha hecho y está listo para registrar su tiempo de trabajo. Si necesitas ayuda, ponte en contacto con nosotros. Con clockin todo es fácil, incluso comunicarse con nosotros."
      },
      button: {
        your_time_matters: "Enséñame cómo se hace",
        thats_it: "Empezar ahora"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Porque tu tiempo cuenta",
        clock_in: "Sello en",
        clock_in_team: "Equipo de facturación",
        switch_task: "Cambio de sello",
        change_teamleader: "Entrega de la unidad",
        clock_out: "Eliminar",
        thats_it: "¡Eso es!"
      },
      text: {
        your_time_matters: "Con clockin le ayudamos a concentrarse en lo esencial. Registre las horas de trabajo de su equipo con un solo clic.",
        clock_in: "Seleccione una persona que fiche para el equipo y con un solo clic usted fichará directamente. clockin guarda tus datos automáticamente y puedes tenerlo todo controlado en todo momento.",
        clock_in_team: "Simplemente estampe un sello directamente en su equipo. Ya sea todos a la vez o solo miembros individuales.",
        switch_task: "¿Tiene otro proyecto, se toma un descanso o viaja a su próxima cita? Sólo tiene que marcar su nueva actividad. El resto se registrará automáticamente.",
        change_teamleader: "¿Estás terminando de trabajar, tienes que irte o ya no fichas para el equipo? Solo tienes que entregar el dispositivo en la aplicación y todo vuelve a la normalidad.",
        clock_out: "Y con un clic, usted y su equipo habrán fichado. Por supuesto, también puedes fichar a miembros individuales en cualquier momento.",
        thats_it: "Ya lo ha hecho y está listo para registrar el tiempo de trabajo de su equipo. Si necesita ayuda, póngase en contacto con nosotros. Todo es fácil con clockin, incluida la comunicación con nosotros."
      },
      button: {
        your_time_matters: "Enséñame cómo se hace",
        thats_it: "Empezar ahora"
      }
    },
    my_area: {
      heading: {
        welcome: "Bienvenido a su zona",
        my_area: "Mi zona",
        create_time: "Crear tiempo",
        change_time: "Hora correcta",
        absences: "Ausencias y solicitudes",
        settings: "Ajustes personales",
        thats_it: "¡Eso es!"
      },
      text: {
        welcome: "Descubra aún más formas de gestionar su tiempo de trabajo de forma eficaz y sencilla. Echemos un vistazo a tu área.",
        my_area: "El lugar central donde tendrá una visión general instantánea de sus horas de trabajo y horas extraordinarias. Desde aquí puedes gestionar tus horas de trabajo, acceder a tu registro diario, enviar solicitudes y consultar tus tiempos.",
        create_time: "¿Ha olvidado introducir una hora o desea añadir horas más tarde? No se preocupe. Añada los tiempos que faltan, registre las pausas y mantenga al día su cuenta de tiempos de trabajo.",
        change_time: "¿Quieres corregir tus tiempos? No hay problema. Con clockin puedes corregir y ajustar fácilmente los tiempos incorrectos.",
        absences: "Gestione las solicitudes de vacaciones, días de baja por enfermedad y otras ausencias. Controle en todo momento el estado de sus solicitudes y envíe otras nuevas de forma rápida y sencilla con solo unos clics.",
        settings: "Envía mensajes a la empresa o cambia tu configuración personal y, si quieres cambiar tu contraseña, ¡también puedes hacerlo aquí!",
        thats_it: "¡Lo ha conseguido! Ahora puedes gestionar tu tiempo sin esfuerzo, organizar las ausencias y concentrarte en lo importante: tu trabajo. ¡Buena suerte con tu tiempo productivo!"
      },
      button: {
        welcome: "Enséñame cómo se hace",
        thats_it: "Empezar ahora"
      }
    },
    clock: {
      clockin_now: "Ingresa ahora",
      clock_your_first_time_now: "y graba tu primera vez"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "¡Gracias por usar clockin!",
      question: "¿Qué probabilidades hay de que recomiende clockin a amigos o compañeros?",
      very_likely: "Muy probable",
      very_unlikely: "Muy improbable",
      help_us_improve: "¿Cómo podemos mejorar el reloj?",
      what_do_you_agree_with: "¿Con qué afirmaciones está de acuerdo?",
      choose_three_statements: "Elija hasta tres afirmaciones.",
      hard_to_use: "Difícil de manejar",
      lacking_features: "Demasiadas pocas funciones",
      does_not_help_me: "no me facilita la jornada laboral",
      confusing: "confuso",
      poorly_implemented: "Funciones mal implementadas",
      too_buggy: "demasiado propenso a errores",
      too_slow: "largos tiempos de carga",
      what_else: "¿Hay algo más que quiera decirnos?",
      can_we_ask_you_a_few_questions: "¿Podemos hacerle algunas preguntas más?",
      how_happy_are_you_with_the_introduction_of_clockin: "¿Está satisfecho con la introducción del \"clockin\" en su empresa?",
      how_much_do_you_enjoy_using_clockin: "¿Qué te parece el uso de clockin?",
      how_much_easier_does_clockin_make_your_work: "¿En qué medida facilita el fichaje su trabajo diario?",
      how_happy_are_you_with_the_following_aspects: "¿Cuál es su grado de satisfacción con los siguientes puntos?",
      clarity_of_the_app: "Claridad de la aplicación",
      simplicity_of_use: "Simplicidad de funcionamiento",
      app_features: "Funciones de la aplicación",
      feedback_received: "Hemos recibido sus comentarios. Gracias por su tiempo.",
      thanks_for_taking_the_time: "Gracias por su tiempo.",
      what_can_we_do_to_improve: "¿Puede contarnos algo más sobre su experiencia para que podamos hacerlo aún mejor la próxima vez?",
      what_can_we_do_to_get_it_right: "¿Puede contarnos más sobre su experiencia para que podamos hacerlo bien la próxima vez?",
      comment_placeholder: "Su mensaje"
    }
  },
  travel_logs: {
    add: "Añadir detalles del viaje",
    edit: "Editar los detalles del viaje",
    saving: "Los detalles del viaje se guardan...",
    saved_successfully: "Detalles del viaje guardados correctamente",
    unable_to_save: "Por desgracia, eso no funcionó 😢"
  },
  attach_file: "Adjuntar archivo",
  image_to_text: {
    info: "Asegúrese de que el texto sea claramente reconocible y pueda verse en su totalidad en la imagen.",
    attach_image: "Adjuntar foto",
    processing: "Su texto se leerá en.",
    processing_failed: "Por desgracia, la importación no funcionó 😢.",
    no_text_found: "No se ha podido reconocer ningún texto."
  },
  correction_enter_reason: "Por favor, proporcione una razón para la corrección.",
  daily_notes: {
    add: "Escriba una nota",
    edit: "Editar nota",
    saving: "La nota se guarda...",
    saved_successfully: "¡Nota guardada correctamente!",
    unable_to_save: "Por desgracia, eso no funcionó 😢",
    no_notes_yet: "No se ha creado ninguna nota",
    create_note: "Cree"
  },
  calendar_sync: {
    title: "Sincronizar programación",
    description: "Sincroniza tu agenda de trabajo con un calendario y controla las citas antiguas y nuevas.",
    url: "Dirección en formato iCal",
    url_description: "Puede utilizar esta dirección para acceder a este calendario desde otras aplicaciones.",
    note: "Nota",
    note_description: "En algunos calendarios, las nuevas citas pueden tardar hasta 24 horas en aparecer.",
    sync_now: "Sincronizar calendario",
    copied: "Url del calendario copiada."
  },
  registration: {
    skip_all: "Saltar todo",
    already_signed_up: "Ya tengo una cuenta",
    title_1: "¡Vamos a empezar! ¿Qué horas te gustaría grabar con clockin?",
    description_1: "Personalicemos el reloj para usted",
    option_1_a: "Tiempo de trabajo general (entrada, salida y pausa)",
    option_1_b: "Horario de trabajo del proyecto",
    title_2: "¿Quiere documentarse?",
    description_2: "¿Qué requisitos deben cumplirse para ello?",
    option_2_a: 'Fotos',
    option_2_b: "Bocetos",
    option_2_c: "Función Nota",
    option_2_d: "Listas de control y formularios",
    option_2_e: "Archivos digitales de proyectos",
    title_3: "¿Qué más le gustaría digitalizar?",
    description_3: "Hay mucho más por descubrir en clockin, quizá haya algo para usted.",
    option_3_a: "Vacaciones",
    option_3_b: "Enfermedades y ausencias",
    option_3_c: "Expediente personal digital",
    option_3_d: "Análisis de empresas",
    option_3_e: "Planificación del despliegue",
    option_3_f: "Asesor fiscal en materia de transferencia de datos (DATEV)",
    title_4: "¿En qué sector opera su empresa?",
    description_4: "Queremos conocerle mejor para poder adaptar mejor el reloj a sus necesidades.",
    option_4_a: "servicios",
    option_4_b: "Artesanía",
    option_4_c: "Salud y bienestar",
    option_4_d: "Compras, pedidos y comercio",
    option_4_e: "Hostelería",
    option_4_f: "Automóviles, transporte y maquinaria",
    option_4_g: "Otros sectores",
    title_5: "¿Cuántos empleados tiene su empresa?",
    description_5: "En función del número de empleados, podemos adaptar el fichaje al tamaño de su empresa.",
    title_6: "¡Muy bien! Su clockin está ahora configurado",
    description_6: "Todo lo que necesitamos es tu nombre.",
    input_6_a: "Empresa",
    input_6_b: "Nombre",
    input_6_c: "Apellido",
    input_6_d: "Número de teléfono",
    title_7: "¡Estás listo para empezar! ¡Prueba clockin 14 días gratis!",
    input_7_a: "Su dirección de correo electrónico",
    description_7: "¿A qué dirección de correo electrónico debemos enviar su contraseña?",
    input_7_b: "Así es como me di cuenta",
    how_did_you_hear_about_clockin: "¿Cómo se enteró de la existencia de clockin?",
    recommendation_option_1: "Recomendación",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Búsqueda en Internet",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Plataforma de comparación",
    recommendation_option_7: "Revistas y artículos en línea",
    known_from: "Conocido por",
    agb_1: "Al enviar el formulario, acepta la ",
    agb_2: 'AGB',
    agb_3: " y el ",
    agb_4: "Política de privacidad",
    start: "Prueba de inicio",
    validation_failed: "Rellene todos los campos correctamente."
  },
  clocki: {
    listening_heading: "Te estoy escuchando",
    listening_subtext: "¿Cómo puedo ayudarle?",
    hi_0: "Hola, ¿en qué puedo ayudarle?",
    hi_1: "Hola, ¿en qué puedo ayudarte?",
    hi_2: "Hola, ¿en qué puedo ayudarle?",
    hi_3: "Moin moin, ¿qué puedo hacer por usted?",
    hi_4: "Hola, ¿en qué puedo ayudarle?",
    hi_5: "Hola, ¿en qué puedo ayudarle?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Lamentablemente, el reconocimiento de voz no parece funcionar en tu dispositivo.",
    microphone_permission_denied: "Lamentablemente, no tengo acceso a su micrófono. Por favor, compruebe las autorizaciones en los ajustes para que pueda oírle.",
    please_speak: "Ya puedes hablar con Clocki",
    create_activity: "Crear una actividad",
    modify_activity: "Cambiar actividad",
    delete_activity: "Eliminar actividad",
    create_daily_note: "Crear una nota diaria",
    search_project: "Buscar un proyecto",
    note_copied: "Nota copiada",
    create_absence_request: "Solicitar ausencia",
    delete_absence: "Borrar ausencia",
    confirm_deletion: "¿Estás seguro de que tu {activity_label} Estampado desde {date} ¿Debería eliminarse el reloj?",
    confirm_absence_deletion: "¿Está seguro de que su solicitud de {category} del {startDate} hasta {endDate} ¿Quieres eliminar?",
    task_before_modification: "Antes: {task}",
    starts_at_before_modification: "Hora de inicio antes: {startsAt}",
    ends_at_before_modification: "Hora de finalización antes: {endsAt}",
    something_went_wrong: "Oh, algo ha ido mal, por favor inténtelo de nuevo más tarde.",
    was_this_helpful: "¿Podría ayudarte Clocki?",
    actions: {
      CREATE_ABSENCE: {
        title: "Confirmar ausencia"
      },
      CREATE_DAILY_NOTE: {
        title: "Crear una nota ahora",
        daily_notes_disabled: "Lamentablemente, la función de notas está desactivada. Pide a tu administrador que active la función en el centro de ofimática.",
        success: "Nota guardada correctamente en el registro diario 🎉."
      },
      CREATE_PROJECT_NOTE: {
        title: "Crear documentación ahora",
        created_by_clocki: "Creado con Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Abrir \"Mis tiempos\" ahora"
      },
      REDIRECT_TO_MY_AREA: {
        title: "Abrir ahora \"Mi espacio"
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Abrir \"Cambiar contraseña\" ahora"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Sello \"tiempo de trabajo\" ahora",
        PAUSE: "Sello \"Pausa\" ahora",
        DRIVING_TIME: "Sello \"tiempo de viaje\" ahora",
        LOGOUT: "Desbloquear ahora"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "¿Te gusta usar Clockin?"
  },
  translation_failed: "Desafortunadamente, la traducción no funcionó 😕",
  video_transcript_not_available: "No hay transcripción disponible",
  video_upload_succeeded: "Subida de vídeo completada.",
  video_upload_failed: "Fallo en la subida del vídeo.",
  video_send_failed: "El vídeo no pudo emitirse en ese momento. Lo intentaremos de nuevo más tarde.",
  uploading_video: "Subiendo vídeo...",
  language_selection_header: "Seleccionar idioma",
  language_selection_message: "Elige tu idioma preferido",
  shifts: {
    my_shifts: "Mis turnos",
    free_shifts: "Turnos libres",
    next_shift: "Tu próximo turno",
    shift_not_found: "No se han encontrado capas",
    show_shift_plan: "Consulta este horario de turnos",
    no_shift_place: "No se especifica la ubicación",
    no_shifts_assigned: "Actualmente no estás asignado a ningún turno",
    free_shifts_unavailable: "Actualmente no hay turnos gratuitos disponibles",
    filter_shift_plans: "Horarios de turnos de filtro",
    no_shift_plans_available: "No hay horarios de turnos disponibles",
    filter_locations: "Lugares de filtrado",
    no_locations_available: "No hay plazas disponibles",
    no_plan_selected: "No se seleccionó el horario de turnos",
    no_shifts_for_plan: "No se encontraron capas para este plan",
    no_shifts_for_location: "No se encontraron cambios para la ubicación seleccionada",
    unknown_shift_plan: "Horario de turnos desconocido",
    unknown_location: "Ubicación desconocida",
    loading_more_shifts: "Carga más capas..."
  },
  clockin_reminder_title: "¿Ya estás en el trabajo? 🔔",
  clockin_reminder: "Recuerda fichar.",
  clockout_reminder_title: "¿Ya has llegado al final del día? 🔔",
  clockout_reminder: "No olvides fichar la salida.",
  choose_clockin_reminder_time: "Hora del recordatorio de fichar",
  choose_clockout_reminder_time: "Hora de recordatorio de salida",
  choose_break_reminder_time: "Duración de la pausa",
  saved_successfully: "Salvados 👍 con éxito",
  clock_reminder_channel_name: "Recordatorios de sellos",
  clock_reminder_channel_description: "Recordatorios para fichar entrada y salida",
  break_reminder_title: "¿Sigues tomando un descanso? ⏰",
  break_reminder: "Nota: Tu tiempo de descanso sigue corriendo.",
  // Video component translations
  video_not_supported: "Tu dispositivo no soporta el vídeo :/",
  video_loading_error: "Vídeo de carga de error",
  video_retry: "Recarga"
};